export const assigneeFieldNameMapping = {
  unassigned: "Unassigned",
  mentions: "Mentions",
  mentioned: "Mentions",
};
export default assigneeFieldNameMapping;
